import React from "react";
import { Link } from "react-router-dom";
import LegalPage, { LegalSection } from "./LegalPage";

export default function PrivacyPolicyPage() {
  return (
    <LegalPage title="Privacy Policy" updated="October 5, 2026">
      <p>
        Progressive Venture LLC ("Progressive Venture", "we", "us") operates
        the text messaging for Grace (Gracewell), an AI companion device for
        older adults. This Privacy Policy explains what information we collect
        for this service and how we use it.
      </p>

      <LegalSection heading="Information we collect">
        <ul>
          <li>
            <strong>Grace family contacts:</strong> the names and mobile phone
            numbers of family members who have agreed to receive video-call
            invitations from a Grace device.
          </li>
          <li>
            <strong>Consent records:</strong> when and how each family member
            agreed to receive text messages.
          </li>
          <li>
            <strong>Messaging records:</strong> the date, time and delivery
            status of the text messages we send, and any replies such as STOP
            or HELP.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="How we use it">
        <ul>
          <li>
            to send a video-call invitation when the user of a Grace device
            asks to call that family member;
          </li>
          <li>to respond to HELP requests and honour STOP (opt-out) requests;</li>
          <li>to keep the service secure and meet our legal obligations.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Sharing">
        <p>
          <strong>
            We do not sell or share your SMS opt-in data or personal
            information with third parties for marketing purposes.
          </strong>
        </p>
        <p>
          We share information only with service providers that deliver our
          messages (for example, our SMS provider), solely to send them, or
          where the law requires it. SMS opt-in data and consent are never
          shared with third parties.
        </p>
      </LegalSection>

      <LegalSection heading="Your choices">
        <ul>
          <li>
            Reply <strong>STOP</strong> to any text message to stop receiving
            texts. You will get one confirmation and no further messages.
          </li>
          <li>
            Reply <strong>HELP</strong> for help, or email us at{" "}
            <a href="mailto:info@skew.digital">info@skew.digital</a>.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="Retention and security">
        <p>
          We keep personal information only while it is needed to provide the
          service. Family contact details are deleted when a family member
          opts out or the Grace device's account is closed. We use reasonable
          safeguards to protect the information we hold.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Progressive Venture LLC ·{" "}
          <a href="mailto:info@skew.digital">info@skew.digital</a>
        </p>
        <p>
          We may update this policy. Changes are posted on this page with a new
          "Last updated" date. See also our{" "}
          <Link to="/gracewell/termsandconditions">Terms &amp; Conditions</Link>.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
